import React, { ReactElement } from 'react';
import { Button } from 'src/domains/common/components/button/button';

interface NewCampaignButtonsPropsType {
    onClose: () => void;
    onSaveAsDraft: () => void;
    onActivate: () => void;
}
export const NewCampaignButtons = ({
    onClose,
    onSaveAsDraft,
    onActivate,
}: NewCampaignButtonsPropsType): ReactElement => (
    <>
        <Button
            variant='ghost'
            onClick={onClose}
            dataTest='campaign-close-button'
        >
            Close
        </Button>

        <Button
            variant='secondary'
            onClick={onSaveAsDraft}
            dataTest='campaign-save-as-draft-button'
        >
            Save as Draft
        </Button>

        <Button
            variant='primary'
            onClick={onActivate}
            dataTest='campaign-activate-button'
        >
            Activate
        </Button>
    </>
);

interface DraftCampaignButtonsPropsType {
    onClose: () => void;
    onUpdate: () => void;
    onActivate: () => void;
}
export const DraftCampaignButtons = ({
    onClose,
    onUpdate,
    onActivate,
}: DraftCampaignButtonsPropsType): ReactElement => (
    <>
        <Button
            variant='ghost'
            onClick={onClose}
            dataTest='campaign-close-button'
        >
            Close
        </Button>

        <Button
            variant='secondary'
            onClick={onUpdate}
            dataTest='campaign-update-button'
        >
            Update
        </Button>

        <Button
            variant='primary'
            onClick={onActivate}
            dataTest='campaign-activate-button'
        >
            Activate
        </Button>
    </>
);

interface ActiveCampaignButtonsPropsType {
    onClose: () => void;
    onPause: () => void;
    onUpdate: () => void;
}
export const ActiveCampaignButtons = ({ onClose, onPause, onUpdate }: ActiveCampaignButtonsPropsType): ReactElement => (
    <>
        <Button
            variant='ghost'
            onClick={onClose}
            dataTest='campaign-close-button'
        >
            Close
        </Button>
        <Button
            variant='secondary'
            onClick={onPause}
            dataTest='campaign-pause-button'
        >
            Pause
        </Button>
        <Button
            variant='primary'
            onClick={onUpdate}
            dataTest='campaign-update-button'
        >
            Update
        </Button>
    </>
);

interface PausedCampaignButtonsPropsType {
    onClose: () => void;
    onUpdate: () => void;
    onReactivate: () => void;
}
export const PausedCampaignButtons = ({
    onClose,
    onUpdate,
    onReactivate,
}: PausedCampaignButtonsPropsType): ReactElement => (
    <>
        <Button
            variant='ghost'
            onClick={onClose}
            dataTest='campaign-close-button'
        >
            Close
        </Button>
        <Button
            variant='secondary'
            onClick={onUpdate}
            dataTest='campaign-update-button'
        >
            Update
        </Button>
        <Button
            variant='primary'
            onClick={onReactivate}
            dataTest='campaign-reactivate-button'
        >
            Reactivate
        </Button>
    </>
);
